import { render } from "./ListeFicheStockPage.vue?vue&type=template&id=6f1140f7&ts=true"
import script from "./ListeFicheStockPage.vue?vue&type=script&lang=ts"
export * from "./ListeFicheStockPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__